import axios from 'axios';
import Cookies from 'universal-cookie';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function authHeaders() {
    const token = new Cookies().get('token');
    return { headers: { authorization: `Bearer ${token}` } };
}

const base = (projectUuid) => `${API_BASE}/project/${projectUuid}/behavioral-economics`;

// --- Analyses (cards) ---
export function listBeAnalyses(projectUuid) {
    return axios.get(`${base(projectUuid)}/analyses`, authHeaders());
}

export function createBeAnalysis(projectUuid, title = null) {
    return axios.post(`${base(projectUuid)}/analyses`, { title }, authHeaders());
}

export function deleteBeAnalysis(projectUuid, analysisUuid) {
    return axios.delete(`${base(projectUuid)}/analyses/${analysisUuid}`, authHeaders());
}

// --- Per-analysis parts ---
export function getBeSources(projectUuid, analysisUuid) {
    return axios.get(`${base(projectUuid)}/analyses/${analysisUuid}/sources`, authHeaders());
}

export function saveBeSources(projectUuid, analysisUuid, selection) {
    return axios.post(`${base(projectUuid)}/analyses/${analysisUuid}/sources`, selection, authHeaders());
}

// type: be_biases | be_report | be_insights
export function generateBeArtifact(projectUuid, analysisUuid, type) {
    return axios.post(`${base(projectUuid)}/analyses/${analysisUuid}/${type}/generate`, {}, authHeaders());
}

export function getBeArtifact(projectUuid, analysisUuid, type) {
    return axios.get(`${base(projectUuid)}/analyses/${analysisUuid}/${type}`, authHeaders());
}
